module.exports = __webpack_public_path__ + "static/media/Charlotte Sun.72e95899.png";